module.exports = __webpack_public_path__ + "assets/img/main_background_small.3c6ebdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/previews/main_background_small.jpg
// module id = 47
// module chunks = 0